// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const PurchaseOrderProjectViewPurchaseOrderStateValues = [
	"INITIAL",
	"RELEASED",
	"CONFIRMED",
	"PARTIALLY_RECEIVED",
	"RECEIVED",
	"CANCELLED",
] as const;

export type PurchaseOrderProjectViewPurchaseOrderState =
	(typeof PurchaseOrderProjectViewPurchaseOrderStateValues)[number];

export const getPurchaseOrderProjectViewPurchaseOrderStateLabels = () => ({
	INITIAL: t("initial"),
	RELEASED: t("released"),
	CONFIRMED: t("confirmed"),
	PARTIALLY_RECEIVED: t("partially_received"),
	RECEIVED: t("received"),
	CANCELLED: t("cancelled"),
});

export const getPurchaseOrderProjectViewPurchaseOrderStateLabel = (
	value: PurchaseOrderProjectViewPurchaseOrderState,
): string => {
	return getPurchaseOrderProjectViewPurchaseOrderStateLabels()[value];
};
